import { mappedStandardsData } from './atoms'
import React, { useMemo } from 'react'
import { StandardsMapping } from './types'
import { Table } from 'shared/ui/Table/Table'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'

export function StandardsTable() {
  const items = useAtomValue(mappedStandardsData)
  const columns = useMemo(() => {
    return [
      {
        title: 'Sheet ID',
        width: 50,
        rowContent({ sheetId }: StandardsMapping) {
          return sheetId
        },
      },
      {
        title: 'Mapped To',
        width: 50,
        rowContent({ mappedTo }: StandardsMapping) {
          return mappedTo
        },
      },
      {
        title: 'Mapped ID',
        width: 50,
        rowContent({ mappedId }: StandardsMapping) {
          return mappedId
        },
      },
    ]
  }, [])
  if (!items) return null
  return <Table columns={columns} items={items} />
}
